<template>
  <div
    class="notification-activity_icon bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500"
    style="width: 80px"
  >
    <FontIcon class="icon-stars" />+<FontIcon class="icon-sexual" />
  </div>
</template>

<script lang="ts" setup>
import FontIcon from '@/components/inputs/icon/font-icon/FontIcon.vue';
</script>
